import { render, staticRenderFns } from "./learning-map.vue?vue&type=template&id=2e970ec9&scoped=true&"
import script from "./learning-map.ts?vue&type=script&lang=ts&"
export * from "./learning-map.ts?vue&type=script&lang=ts&"
import style0 from "./learning-map.scss?vue&type=style&index=0&id=2e970ec9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e970ec9",
  null
  
)

export default component.exports